<template>
  <Webview>
    <Header title="忘記密碼" :back="back"></Header>
    <div class="wv_page _fill">
      <template v-for="(item, key) in form">
        <Control :passData="item" :update="update" :check="check"></Control>
      </template>
    </div>
    <div class="wv_button">
      <div class="main_btn _main" @click="submit">確認</div>
    </div>
  </Webview>
</template>

<script>
//api
import { resetPassword } from "@/api/auth";
export default {
  mixins: [
    require("@mix/form").default,
    require("./mixins/formData").default
  ],
  methods: {
    back() {
      this.$router.push({ name: "login" }) //在 resetPassword 頁面時,按下返回回到 login 頁面
    },
    submit() {
      this.checkAll();
      if (!this.isAllValid) return false;

      this.register();
    },
    async register() {
      try {
        const { email, token } = this.$route.query;
        const params = {
          email: email,
          token: token,
          password: this.password
        }
        const res = await resetPassword(params);
        NOTIFICATION("s", "重設密碼成功！請重新登入");
        this.back();
      }
      catch (error) {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: "重設密碼" }));
      }
    }
  }
}
</script>

<style>
</style>